import type { CityConfig } from "../city-template/types";

export const florenceALConfig: CityConfig = {
  city: "Florence",
  state: "Alabama",
  stateAbbr: "AL",
  slug: "florence-al",
  route: "/cities/florence-al",
  title: "Emergency Passport Florence, AL | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Florence, AL — as fast as 24 hours. Serving the Shoals area and Northwest Alabama. A+ BBB rated registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Florence, AL",
  heroSubtitle: "Shoals music festival trip to Ireland with one week notice? Tennessee River fishing trip to Canada and your passport expired? UNA study abroad program need fast documents? We help Florence residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Florence%20Alabama%20skyline%20along%20the%20Tennessee%20River%20in%20the%20Shoals%20area%20historic%20downtown%20Renaissance%20Tower%20UNA%20campus%20Wilson%20Dam%20river%20scenery%20golden%20hour%20warm%20sunset%20light%20professional%20drone%20photography%20soft%20natural%20tones%20Southern%20charm&width=1800&height=700&seq=florence-al-hero-2026&orientation=landscape",
  heroImageAlt: "Florence Alabama Shoals area Tennessee River city skyline at golden hour",
  geoPosition: "34.7991;-87.6772",
  geoPlacename: "Florence, Alabama",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree St NW, Suite 1000, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 265 miles southeast of Florence via I-65/I-20",
  },
  nearbyCitiesZips: [
    { name: "Florence", zips: "35630, 35631" },
    { name: "Muscle Shoals", zips: "35661, 35662" },
    { name: "Sheffield", zips: "35660" },
    { name: "Tuscumbia", zips: "35674" },
    { name: "Russellville", zips: "35653, 35654" },
    { name: "Killen", zips: "35645" },
    { name: "Rogersville", zips: "35652" },
    { name: "Athens", zips: "35611, 35613" },
    { name: "Decatur", zips: "35601" },
    { name: "Hamilton", zips: "35570" },
    { name: "Haleyville", zips: "35565" },
    { name: "Lawrenceburg", zips: "38464" },
    { name: "Pulaski", zips: "38478" },
    { name: "Corinth", zips: "38834" },
    { name: "Iuka", zips: "38852" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Shoals area departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "The Shoals Region", desc: "Serving Florence, Muscle Shoals, Sheffield, Tuscumbia, and NW Alabama" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Huntsville, AL", route: "/cities/huntsville" },
    { name: "Fast passport renewal in Decatur, AL", route: "/cities/decatur-al" },
    { name: "Emergency passport help in Birmingham, AL", route: "/cities/birmingham" },
    { name: "Urgent passport services in Nashville, TN", route: "/cities/nashville" },
    { name: "Same-day passport help in Atlanta, GA", route: "/cities/atlanta" },
    { name: "Passport courier services in Montgomery, AL", route: "/cities/montgomery-al" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Florence remotely via secure courier. We do not have a walk-in office in Florence — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for the Shoals and Northwest Alabama.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Lauderdale County and the Shoals including Colbert, Franklin, and Lawrence counties",
  serviceAreaIntro: "From the historic downtown Renaissance Tower and the Tennessee River waterfront of Florence to the legendary recording studios of Muscle Shoals, from the Wilson Dam overlooks to the charming streets of Tuscumbia and Sheffield, from the UNA campus and the W.C. Handy festivals to the growing communities of Killen and Rogersville — Fast Passport Center serves the entire Shoals and Northwest Alabama region. We regularly help travelers from Lauderdale County, Colbert County, and the Quad Cities get their passports fast without the 265-mile drive to Atlanta.",
  nearbyCitiesIntro: "We serve all Florence neighborhoods and the surrounding Shoals area including Muscle Shoals, Sheffield, Tuscumbia, Russellville, Killen, and Rogersville. If you are anywhere in Lauderdale County, Colbert County, or the Tennessee Valley, we have you covered.",
  howItWorksIntro: "Most Florence travelers complete everything online and ship documents overnight. No need to drive to Atlanta, Nashville, or Memphis and wait in line at a regional agency.",
  mistakesIntro: "Florence travelers often face a 4+ hour drive to the nearest regional passport agency in Atlanta. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Florence and Shoals area travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Florence? Here are the most common ones we hear from Shoals area travelers.",
  statePageRoute: "/states/alabama",
  statePageName: "Alabama",
  dmvWebsite: "https://www.alea.gov/driver-license",
  dmvLabel: "AL Law Enforcement Agency — Driver License Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Florence travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Rebecca C.",
      location: "Florence, AL",
      rating: 5,
      text: "Our Ireland trip for the music festival was in 5 days and I couldn't find my passport. Fast Passport Center got me a replacement in 30 hours. From the Shoals to Dublin in a week — couldn't believe how smooth it was!",
      service: "Lost Passport Replacement",
    },
    {
      name: "Tommy S.",
      location: "Muscle Shoals, AL",
      rating: 5,
      text: "Medical emergency family trip to Toronto. Fast Passport Center got all four family passports in 26 hours. The dedicated agent was incredible. Shoals area's best-kept secret for urgent travel.",
      service: "Emergency Passport",
    },
    {
      name: "Megan H.",
      location: "Sheffield, AL",
      rating: 5,
      text: "UNA study abroad to France and my child needed a first passport. Fast Passport Center guided us through everything. Got it in 4 days. Amazing service for Shoals area families!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "florence-al-1",
      name: "Florence Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "210 N Seminary St",
      city: "Florence",
      state: "AL",
      zip: "35630",
      phone: "(256) 764-2411",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Florence",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Florence facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "florence-al-2",
      name: "Lauderdale County Circuit Clerk",
      type: "County Circuit Clerk Passport Acceptance",
      address: "200 S Court St",
      city: "Florence",
      state: "AL",
      zip: "35630",
      phone: "(256) 760-5725",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Florence Courthouse",
      website: "https://lauderdalecountyal.gov",
      websiteLabel: "Lauderdale County Circuit Clerk",
      notes: "Accepts passport applications at the courthouse. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "florence-al-3",
      name: "Muscle Shoals Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 E 6th St",
      city: "Muscle Shoals",
      state: "AL",
      zip: "35661",
      phone: "(256) 381-4321",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles south of Florence",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Muscle Shoals. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "florence-al-4",
      name: "Sheffield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "210 N Nashville Ave",
      city: "Sheffield",
      state: "AL",
      zip: "35660",
      phone: "(256) 383-0611",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "3 miles south of Florence",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Sheffield and Colbert County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "florence-al-5",
      name: "Tuscumbia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "701 N Main St",
      city: "Tuscumbia",
      state: "AL",
      zip: "35674",
      phone: "(256) 383-6911",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles southeast of Florence",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Tuscumbia. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4+ hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Florence photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Lauderdale County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Florence applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Atlanta regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Shoals area families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Florence travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Florence." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Florence address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Florence before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Florence for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4+ hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Florence?", a: "Fast Passport Center offers fast passport renewal in Florence in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Florence?", a: "The nearest regional passport agency to Florence is the Atlanta Passport Agency, approximately 265 miles southeast via I-65/I-20. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Florence without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Florence?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 4+ hours from Florence — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for the Shoals and Northwest Alabama residents." },
    { q: "Do you serve the entire Shoals area?", a: "Absolutely. Fast Passport Center serves the entire Shoals and Northwest Alabama region including Florence, Muscle Shoals, Sheffield, Tuscumbia, Russellville, and surrounding areas. Our courier service works seamlessly from any address in Lauderdale County or Colbert County." },
    { q: "Can I expedite a child passport in Florence?", a: "Yes. Fast Passport Center expedites child passports in Florence for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Shoals area families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Florence with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Florence", address: "2701 Cloverdale Rd, Florence, AL 35633", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Florence", address: "210 Cox Creek Pkwy, Florence, AL 35630", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Muscle Shoals", address: "508 Avalon Ave, Muscle Shoals, AL 35661", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Supercenter — Russellville", address: "13675 Highway 43, Russellville, AL 35653", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "ALEA Driver License Office — Florence",
      address: "4020 Hatch Blvd, Sheffield, AL 35660",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Primary ALEA office serving the Shoals. Driver license and REAL ID. Appointment recommended.",
      featured: true,
    },
    {
      name: "ALEA Driver License Office — Russellville",
      address: "14455 Highway 43, Russellville, AL 35653",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Franklin County. REAL ID available.",
      featured: false,
    },
    {
      name: "ALEA Driver License Office — Athens",
      address: "22035 US Highway 72, Athens, AL 35611",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Limestone County. About 40 minutes east.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MSL",
      name: "Northwest Alabama Regional Airport",
      distance: "8 miles east of Florence",
      address: "1729 T Ed Campbell Dr, Muscle Shoals, AL 35661",
      note: "Regional airport with service to Atlanta via Contour Airlines. About 15 minutes from Florence.",
      flightUrl: "https://www.flymsl.com/",
      flightLabel: "MSL Airport",
      featured: true,
    },
    {
      code: "HSV",
      name: "Huntsville International Airport",
      distance: "75 miles east of Florence",
      address: "1000 Glenn Hearn Blvd SW, Huntsville, AL 35824",
      note: "Major North Alabama airport with direct flights nationwide. About 1 hour 15 minutes from Florence.",
      flightUrl: "https://www.flyhuntsville.com/",
      flightLabel: "HSV Airport",
      featured: false,
    },
    {
      code: "BHM",
      name: "Birmingham-Shuttlesworth International Airport",
      distance: "115 miles southeast of Florence",
      address: "5900 Messer Airport Hwy, Birmingham, AL 35212",
      note: "Major Alabama airport with direct flights nationwide. About 2 hours 15 minutes from Florence.",
      flightUrl: "https://www.flybirmingham.com/",
      flightLabel: "BHM Airport",
      featured: false,
    },
  ],
};